import Vue from 'vue'
import Utils from './Utils'

export default {
  akceptujRegulamin () {
    return Vue.http.post('oswiadczenia', ['REGULAMIN']).then(response => { }, Utils.przechwycBlad)
  }
}
